import { forwardRef, useEffect } from 'react';
import Player from '@vimeo/player';
import * as Styled from './player.style';

type Props = {
  name: string;
  embed: string | null;
  source?: string;
  autoPlay?: boolean;
};

const MediaPlayer = forwardRef(
  (
    { name, embed, source, autoPlay }: Props,
    ref: React.Ref<HTMLIFrameElement>
  ) => {
    const hasVideo = !!embed;
    const isVimeo = source === 'vimeo';

    useEffect(() => {
      if (isVimeo) {
        const el = document.getElementById('vimeo-content');
        if (el && embed) {
          new Player(el, {
            url: embed,
            byline: false,
            title: false,
            portrait: false,
          });
        }
      }
    }, [isVimeo, embed]);

    return !hasVideo ? null : !isVimeo ? (
      <Styled.PlayerOuter>
        <Styled.PlayerInner>
          <iframe
            ref={ref}
            src={
              embed +
              (autoPlay ? (embed.includes('?') ? '&a=true' : '?a=true') : '')
            }
            allow="fullscreen; autoplay;"
            allowFullScreen
            title={name}
          ></iframe>
        </Styled.PlayerInner>
      </Styled.PlayerOuter>
    ) : (
      <div id="vimeo-content" />
    );
  }
);

export default MediaPlayer;
